import { ChatId } from 'src/app/store/samwin/chats/models/chat-id';
import { Command } from './command';

export class InitChatCommand extends Command {
   public static readonly commandType: string = 'samwin/init-chat';

   public constructor(chatId: ChatId) {
      super(InitChatCommand.commandType, chatId);
   }
}
